export default {
  methods: {
    initDropEvents ({target, dragEnter, dragLeave, drop}) {
      const enterEvents = ['dragenter', 'dragover']
      const leaveEvents = ['dragleave', 'drop']
      const events = [...enterEvents, ...leaveEvents]
      if (!target) return
      events.forEach(eventName => {
        target.addEventListener(eventName, this.preventDefaults, false)
      })
      if (dragEnter) {
        enterEvents.forEach(eventName => {
          target.addEventListener(eventName, dragEnter, false)
        })
      }
      if (dragLeave) {
        leaveEvents.forEach(eventName => {
          target.addEventListener(eventName, dragLeave, false)
        })
        target.addEventListener('mouseleave', dragLeave, false)
      }
      if (drop) {
        target.addEventListener('drop', drop, false)
      }
    },
    preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/initDropEvents.js